import * as types from '../mutation-types';
import { unionState } from '../helpers';
import { type } from 'jquery';

const state = () => ({
	orders: [],
});

const actions = {
	fetchAll({ commit }) {
		return axios.get('/api/orders').then(response => {
			commit(types.STORE_ORDERS, response.data);

			return response.data;
		});
	},

	fetch({ commit }, { id }) {
		return axios.get(`/api/orders/${id}`).then(response => {
			commit(types.STORE_ONE_ORDER, response.data);

			return response.data;
		});
	},
	fetchbybranchid({ commit }, { restaurantId, branchId, active }) {
		if (active == 'Active') {
			return axios.get(`/api/restaurants/${restaurantId}/branches/${branchId}/orders?active=true`).then(response => {
				commit(types.STORE_ORDERS_BY_BRANCH, response.data);

				return response.data;
			});
		}
		else {
			return axios.get(`/api/restaurants/${restaurantId}/branches/${branchId}/orders?active=false`).then(response => {
				commit(types.STORE_ORDERS_BY_BRANCH, response.data);

				return response.data;
			});
		}
	},
	statusorder({ commit }, { restaurantId, branchId, orderId, statusFood }) {
		return axios.put(`/api/restaurants/${restaurantId}/branches/${branchId}/orders/${orderId}/status`, {
			status: statusFood
		}).then(response => {
			commit(types.STATUS, response.data);

			return response.data;
		});
	},

	paid({ commit }, { orderId, paid }) {
		return axios.put(`/api/orders/${orderId}/paid`, {
			paid: paid
		}).then(response => {
			commit(types.SET_PAID, orderId);

			return response.data;
		});
	},

	status({ commit }, { orderId , currentStatus}) {
		return axios.put(`/api/orders/${orderId}/status`, {
				currentStatus
		}).then(response => {
			commit(types.SET_STATUS, {orderId , currentStatus});
			return response.data
		});
	},

	cancel({ commit }, { orderId, status }) {
		return axios.put(`/api/orders/${orderId}/cancel`, {
			status: status
		}).then(response => {
			commit(types.CANCEL, orderId);

			return response.data;
		});
	},

	delete({ commit }, { restaurantId, branchId, orderId }) {
		return axios.delete(`/api/restaurants/${restaurantId}/branches/${branchId}/orders/${orderId}`).then(response => {
			commit(types.DELETE_ONE_ORDER, orderId);
		});
	}
};

const mutations = {
	[types.STORE_ORDERS](state, orders) {
		state.orders = unionState(state.orders, orders);
	},

	[types.STORE_ORDERS_BY_BRANCH](state, orders) {
		state.orders = orders;
	},

	[types.STORE_ONE_ORDER](state, order) {
		state.orders = unionState(state.orders, [order]);
	},

	[types.DELETE_ONE_ORDER](state, id) {
		state.orders = state.orders.filter(o => o.id !== id);
	},

	[types.SET_PAID](state, id) {
		const order = state.orders.find(c => c.id === id);
		order.paid = !order.paid;
	},

	[types.SET_STATUS](state, OrderObj) {
		const order = state.orders.find(c => c.id === OrderObj.orderId);
		order.status = OrderObj.currentStatus;
	},

	[types.CANCEL](state, orderId) {
		const order = state.orders.find(c => c.id === orderId);
		order.status = 4;
	},
};

const getters = {
	getAll: state => branchId => state.orders.filter(o => true),
	getById: state => id => state.orders.find(o => o.id === id),
};

export default {
	namespaced: true,
	state,
	mutations,
	actions,
	getters
};